import React from 'react';

import ErrorBoundary from 'buyside/components/presentation/ErrorBoundary/errorBoundary';
import CompensationSubmissionContainer from 'buyside/components/container/CompensationSubmission/CompensationSubmissionContainer';

const CompensationSubmissionPageRoot = () => {
  return (
    <ErrorBoundary pageName="compensation submission">
      <CompensationSubmissionContainer />
    </ErrorBoundary>
  );
};

export default CompensationSubmissionPageRoot;
